const routes = [
  {
    path: "/housekeeping-commission",
    name: "housekeeping-commission",
    component: () =>
      import(
        "@/views/housekeeping-commission/HousekeepingCommissionIndex.vue"
      ),
    meta: {
      layout: "default",
      role: ["superadmin", "backoffice", "supervisor", "receptionist"],
      public: false,
    },
  },
];

export default routes;
